import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase/config";

export async function listCashOutProgramsByCartOrderId(cartOrderId) {
  if (!cartOrderId) return [];
  const snap = await getDocs(
    query(
      collection(db, "cashOutPrograms"),
      where("sourceCartOrderId", "==", cartOrderId)
    )
  );
  return snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .sort(
      (a, b) =>
        (Number(a.enrollmentSeq) || 0) - (Number(b.enrollmentSeq) || 0)
    );
}

export async function listCashOutProgramsForUser(userId) {
  if (!userId) return [];
  const snap = await getDocs(
    query(collection(db, "cashOutPrograms"), where("userId", "==", userId))
  );
  return snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .sort(
      (a, b) =>
        (Number(a.enrollmentSeq) || 0) - (Number(b.enrollmentSeq) || 0)
    );
}
